import React from 'react'
import cartData from './../models/cart';

export class ToCartCommonComponent extends React.Component {
  constructor(props) {
    super(props)
    const q = cartData.inCart(props.params.itemId)
    this.state = {
      inCart: q,
      quantity: q
    }
    cartData.subject.subscribe((x)=>{
      this.setState((ps) => {
        const q = cartData.inCart(props.params.itemId)
        if(q > 0) {
          ps.inCart = q
          ps.quantity = q
        } else {
          ps.inCart = 0
          ps.quantity = 1
        }
        return ps
      })
    })

    this.toCart = this.toCart.bind(this)
    this.down = this.down.bind(this)
    this.up = this.up.bind(this)
    this.toCartQuant = this.toCartQuant.bind(this)
  }

  // Набор «только для первого заказа», а покупатель уже заказывал (#315):
  // положить нельзя, а уже лежащий в корзине — не прибавить. Решает сервер.
  firstOrderUsed() {
    return !!this.props.params.bundleFirstOrderUsed
  }

  firstOrderNote(text = 'Набор - только для первого заказа, а у вас заказ уже был') {
    return <div className="item-first-order-used" style={{ color: '#d0021b', fontSize: '13px', lineHeight: '1.3', marginTop: '6px' }}>{text}</div>
  }

  needUnitsInfo() {
    const it = this.props.params
    return it.price_unit && it.price_unit != '' && it.price_one && it.price_one != 0
  }

  down(e) {
    e.preventDefault()
    e.stopPropagation()
    if(this.state.quantity >= 1){
      cartData.updateItem(this.props.params, this.state.quantity - 1)
      this.setState({
        inCart: 0,
        quantity: 1
      })
    }
  }

  up(e) {
    e.preventDefault()
    e.stopPropagation()
    if(this.firstOrderUsed()) return
    if(this.state.quantity >= 1){
      const new_q = this.state.quantity + 1
      cartData.updateItem(this.props.params, new_q)
      this.setState({
        inCart: new_q,
        quantity: new_q
      })
    }
  }

  toCart(e) {
    e.preventDefault()
    e.stopPropagation()
    if(this.firstOrderUsed()) return
    cartData.updateItem(this.props.params, 1)
  }

  currentPrice() {
    const pcs = this.props.params.priceConditions
    const l = pcs.length
    const q = this.state.quantity
    let price = this.props.params.price

    if(l == 0)
      return price

    let found = false
    pcs.forEach((it) => {
      if(!found && it.quantity <= q) {
        price = it.price
        found = true
      }
    })

    return price
  }

  toCartQuant(q) {
    if(this.firstOrderUsed()) return
    cartData.updateItem(this.props.params, q.quantity)
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/to_cart_common/to_cart_common.component.jsx